<script setup lang="ts">
import { computed, ref } from "vue";

import BaseButton from "@/common/components/BaseButton.vue";
import PageWrapper from "@/common/components/PageWrapper.vue";
import type { LinkTab } from "@/common/types";
import CreateKitModal from "@/kits/components/CreateKitModal.vue";
import { useCurrentUser } from "@/users/public/composables";

definePage({
  meta: {
    auth: ["Kits.Read"],
  },
});

const { userHasPermission } = useCurrentUser();

const tabs = computed<LinkTab[]>(() => [
  {
    title: "All",
    to: "/kits/list",
  },
  {
    title: "Archived",
    to: "/kits/list/archived",
  },
]);

const breadcrumbs = [
  {
    label: "Kits",
    to: "#",
  },
];

const isCreateTeamModalOpen = ref(false);
</script>

<template>
  <PageWrapper
    title="Kits"
    :tabs="tabs"
    :breadcrumb-links="breadcrumbs"
  >
    <template #actions>
      <BaseButton
        v-if="userHasPermission('Kits.Write')"
        variant="primary"
        label="Create"
        @click="isCreateTeamModalOpen = true"
      />
    </template>
    <CreateKitModal
      v-model:is-open="isCreateTeamModalOpen"
      :visit-kit-on-create="true"
    />
    <RouterView />
  </PageWrapper>
</template>
